/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAljYU%7Bmin-height%3A5pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr0DIqT%7Balign-self%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138428HPE%7Bmargin-top%3Avar(--ds-space-150%2C9pt)%7D");
import { Fragment, type KeyboardEvent } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import Tabs from '@atlaskit/tabs/tabs';
import Tab from '@atlaskit/tabs/tab';
import TabList from '@atlaskit/tabs/tab-list';
import { type LinkPickerPlugin, type LinkSearchListItemData } from '../../../common/types';
import { LinkSearchError, testIds as searchErrorTestIds } from './link-search-error';
import { LinkSearchList, testIds as listTestIds } from './link-search-list';
import { ScrollingTabList } from './scrolling-tabs';
import { SearchResultsContainer } from './search-results-container';
import { TrackTabViewed } from './track-tab-viewed';
const styles = {
  tabsWrapper: "_3138428HPE"
};
const spinnerContainerStyles = null;
export const testIds: {
  tabsLoadingIndicator: string;
  tabList: string;
  tabItem: string;
  resultListTitle: string;
  searchResultList: string;
  searchResultLoadingIndicator: string;
  searchResultItem: string;
  searchResultIcon: string;
  emptyResultPage: string;
  searchError: string;
} = {
  ...searchErrorTestIds,
  ...listTestIds,
  tabsLoadingIndicator: 'link-picker.tabs-loading-indicator',
  tabList: 'link-picker-tabs',
  tabItem: 'link-picker-tab'
};
export type SearchResultsProps = {
  activePlugin?: LinkPickerPlugin;
  tabs: {
    tabTitle: string;
  }[];
  isLoadingPlugins?: boolean;
  isLoadingResults: boolean;
  isSubmitting?: boolean;
  activeTab: number;
  handleTabChange: (activeTab: number) => void;
  handleSearchListOnChange: (id: string) => void;
  featureFlags?: Record<string, unknown>;
  linkSearchListId: string;
  queryState?: {
    query: string;
  };
  items?: LinkSearchListItemData[] | null;
  activeIndex: number;
  selectedIndex: number;
  handleSelected: (objectId: string) => void;
  handleKeyDown: (e: KeyboardEvent<HTMLElement>) => void;
  error?: unknown;
  adaptiveHeight: boolean;
  retry: () => void;
  shouldRenderNoResultsImage?: boolean;
};
export const SearchResults = ({
  tabs,
  activeTab,
  activePlugin,
  isLoadingPlugins,
  isLoadingResults,
  isSubmitting,
  handleTabChange,
  handleSearchListOnChange,
  featureFlags,
  linkSearchListId,
  error,
  queryState,
  items,
  activeIndex,
  selectedIndex,
  handleSelected,
  handleKeyDown,
  adaptiveHeight,
  retry,
  shouldRenderNoResultsImage
}: SearchResultsProps): JSX.Element => {
  const isActivePlugin = !!activePlugin;
  const tabList = <TabList>
			{tabs.map(tab => <Tab key={tab.tabTitle} testId={testIds.tabItem}>
					{tab.tabTitle}
				</Tab>)}
		</TabList>;
  const ErrorWrapper = ({
    children
  }: {
    children: React.ReactNode;
  }) => !!tabs.length ? <div id={`${testIds.tabList}-${activeTab}-tab`}>{children}</div> : children;
  return <SearchResultsContainer hasTabs={!!tabs.length || isLoadingPlugins} adaptiveHeight={adaptiveHeight} isLoadingResults={isLoadingResults}>
			{isLoadingPlugins && !!queryState && <div className={ax(["_4kiQYAljYU _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _4xdlr0DIqT _2O5Vij7dHp"])}>
					<Spinner testId={testIds.tabsLoadingIndicator} interactionName="link-picker-tabs-loading" size="medium" />
				</div>}
			{!isLoadingPlugins && isActivePlugin && !!queryState && <Fragment>
					{tabs.length > 0 && <Box xcss={styles.tabsWrapper}>
							<Tabs id={testIds.tabList} testId={testIds.tabList} selected={activeTab} onChange={handleTabChange}>
								{featureFlags?.scrollingTabs ? <ScrollingTabList>{tabList}</ScrollingTabList> : tabList}
							</Tabs>
							<TrackTabViewed activePlugin={activePlugin} />
						</Box>}
					{!error && <LinkSearchList id={linkSearchListId} role="listbox" ariaReadOnly={isSubmitting} items={items} isLoading={isLoadingResults} selectedIndex={selectedIndex} activeIndex={activeIndex} onSelect={handleSelected} onChange={handleSearchListOnChange} onKeyDown={handleKeyDown} hasSearchTerm={!!queryState?.query.length} activePlugin={activePlugin} adaptiveHeight={adaptiveHeight} tabPanelId={`${testIds.tabList}-${activeTab}-tab`} shouldRenderNoResultsImage={shouldRenderNoResultsImage} />}

					{error ? activePlugin?.errorFallback?.(error, retry) ?? <ErrorWrapper>
									<LinkSearchError onRetry={retry} />
								</ErrorWrapper> : null}
				</Fragment>}
		</SearchResultsContainer>;
};